module.exports = __webpack_public_path__ + "img/IMG_1370.160b305c.jpg";